import { apolloClient } from "@td/ui";
import { participantTypes } from "../constants";
import CREATE_PRACTICE_TEAM_PARTICIPANT from "../mutations/create_practice_team_participant.graphql";

export const createPracticeTeamParticipant = async (personId, practiceTeamId) => {
  const { data } = await apolloClient.mutate({
    mutation: CREATE_PRACTICE_TEAM_PARTICIPANT,
    variables: {
      practiceTeamId: practiceTeamId.toString(),
      personId: personId.toString(),
      personType: participantTypes.ADMIN,
    },
  });

  return data.createPracticeTeamParticipant;
};

export default createPracticeTeamParticipant;
